module.exports = __webpack_public_path__ + "img/phone.be5030ca.webp";